<template>
  <div>
    <Form
      ref="courseForm"
      :rules="ruleValidate"
      :model="courseInfo"
      :label-width="120"
    >
      <div class="title">基本信息</div>
      <FormItem label="课程名称" prop="title">
        <Input
          style="width: 300px"
          type="text"
          v-model="courseInfo.title"
          placeholder="请输入课程名称，最多不超过50个字"
          :maxlength="50"
          clearable
        />
        <CharCount :max="50" :text="courseInfo.title"></CharCount>
      </FormItem>
      <FormItem label="有效期说明" prop="expiration_note">
        <Input
          style="width: 300px"
          type="text"
          v-model="courseInfo.expiration_note"
          placeholder="请输入课程有效期说明"
          clearable
        />
      </FormItem>

      <FormItem label="主讲老师" prop="teachers">
        <Tag
          type="border"
          closable
          v-for="teacher in courseInfo.teachers"
          :key="teacher.id"
          @on-close="teacherDelete(teacher.id)"
          style="height: 36px; line-height: 32px"
        >
          <Avatar :src="teacher.avatar" />
          {{ teacher.real_name }}
        </Tag>
        <Button
          type="default"
          @click="showSelectTeacher = true"
          :disabled="courseInfo.teachers.length >= 20"
        >
          <i class="ivu-icon ivu-icon-ios-add"></i>选择讲师
        </Button>
        <span class="promt">最多可添加20个讲师</span>
      </FormItem>
      <FormItem label="课程封面" prop="cover">
        <UploadFile
          url="/api/public/img"
          :format="['jpg', 'jpeg', 'gif', 'png']"
          @onSuccess="onUploadSuccess"
        ></UploadFile>
        <div class="tip">
          *尺寸为 220 * 220, 请上传jpg, png格式的图片, 建议图片大小不超过2MB。
        </div>
        <div v-if="courseInfo.cover">
          <img
            :src="courseInfo.cover"
            style="
              width: 88px;
              height: 88px;
              border: 1px solid #efefef;
              padding: 3px;
            "
          />
        </div>
      </FormItem>
      <FormItem label="课程banner" prop="banner" v-if="$route.query.type != 4">
        <UploadFile
          v-if="courseInfo.banner.length < 6"
          url="/api/public/img"
          :format="['jpg', 'jpeg', 'gif', 'png']"
          @onSuccess="onBannerUploadSuccess"
        ></UploadFile>
        <div class="tip">
          *尺寸为 750 * 420, 请上传jpg, png格式的图片, 建议图片大小不超过2MB。
        </div>
        <div class="course-banners" v-if="courseInfo.banner">
          <div
            class="course-banner"
            v-for="(item, index) in courseInfo.banner"
            :key="index"
          >
            <img
              :src="item"
              style="
                width: 150px;
                height: 84px;
                border: 1px solid #efefef;
                margin: 10px;
                padding: 3px;
              "
            />
            <div class="delete" @click="onRemoveImage(index)">
              <i class="ivu-icon ivu-icon-ios-close-circle ivu-input-icon"></i>
            </div>
          </div>
        </div>
      </FormItem>
      <FormItem label="课程详情" v-if="$route.query.type != 4">
        <UEditor v-model="courseInfo.course_details"></UEditor>
      </FormItem>
      <FormItem
        label="是否限制课程库存"
        v-if="
          $route.query.type == 2 ||
          $route.query.type == 5 ||
          $route.query.type == 8 ||
          $route.query.type == 10
        "
      >
        <RadioGroup
          v-model="courseInfo.stock_limit"
          @on-change="onStockLimitChange"
        >
          <Radio :label="0">
            <span>否</span>
          </Radio>
          <Radio :label="1">
            <span>是</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem
        label="课程库存"
        prop="stock"
        v-if="
          courseInfo.stock_limit == 1 &&
          ($route.query.type == 2 ||
            $route.query.type == 5 ||
            $route.query.type == 8 ||
            $route.query.type == 10)
        "
      >
        <Input
          style="width: 150px"
          type="number"
          v-model="courseInfo.stock"
          placeholder="请输入课程库存"
          @keydown.native="intKeydown"
        />
      </FormItem>
      <FormItem
        label="是否分班"
        prop="is_divide_class"
        v-if="$route.query.type == 2 && showClassModule"
      >
        <RadioGroup v-model="courseInfo.is_divide_class">
          <Radio :label="1" :disabled="!!$route.query.id">
            <span>是</span>
          </Radio>
          <Radio :label="0" :disabled="!!$route.query.id">
            <span>否</span>
          </Radio>
        </RadioGroup>
        <div v-if="courseInfo.is_divide_class == 1">
          <RadioGroup
            v-model="courseInfo.class_num_limit"
            :vertical="true"
            @on-change="onClassNumLimitChange"
          >
            <Radio :label="1" :disabled="!allowChangeClassNum">
              <span>限制班级人数</span>
              <Input
                style="width: 150px"
                type="number"
                v-model="courseInfo.class_num"
                placeholder="请输入班级人数"
                :disabled="courseInfo.class_num_limit == 0"
                @keydown.native="intKeydown"
              />
              <span class="promt" style="margin-left: 10px">
                设置班级人数后，自动分班学员数达班级人数后自动满员，所有班级总人数不能超过课程库存数
              </span>
            </Radio>
            <Radio :label="0" :disabled="!allowChangeClassNum">
              <span>不限制班级人数</span>
              <span class="promt" style="margin-left: 10px">
                班级人数不能超过课程库存数
              </span>
            </Radio>
          </RadioGroup>
        </div>
      </FormItem>
      <FormItem
        label="选择助教"
        prop="assist_teachers"
        v-if="$route.query.type == 2 && courseInfo.is_divide_class == 1"
      >
        <Tag
          type="border"
          closable
          v-for="teacher in courseInfo.assist_teachers"
          :key="teacher.id"
          @on-close="assistDelete(teacher.id)"
          style="height: 36px; line-height: 32px"
        >
          <Avatar :src="teacher.avatar" />
          {{ teacher.real_name }}
        </Tag>
        <Button type="default" @click="showSelectAssist = true">
          <i class="ivu-icon ivu-icon-ios-add"></i>选择助教
        </Button>
      </FormItem>
      <FormItem
        label="是否布置作业"
        prop="is_dispatch_homework"
        v-if="$route.query.type != 9 && showHomeworkModule"
      >
        <RadioGroup v-model="courseInfo.is_dispatch_homework">
          <Radio :label="1">是</Radio>
          <Radio :label="0">否</Radio>
        </RadioGroup>
        <FormItem
          label="发布作业"
          prop="dispatch_homework"
          class="form-item-sub"
          v-if="courseInfo.is_dispatch_homework == 1"
        >
          <CheckboxGroup v-model="courseInfo.dispatch_homework">
            <Checkbox :label="0">老师</Checkbox>
            <Checkbox
              :label="1"
              v-if="courseInfo.is_divide_class == 1 && $route.query.type == 2"
              >助教</Checkbox
            >
          </CheckboxGroup>
        </FormItem>
        <FormItem
          label="批改作业"
          prop="correct_homework"
          class="form-item-sub"
          v-if="courseInfo.is_dispatch_homework == 1"
        >
          <CheckboxGroup v-model="courseInfo.correct_homework">
            <Checkbox :label="0">老师</Checkbox>
            <Checkbox
              :label="1"
              v-if="courseInfo.is_divide_class == 1 && $route.query.type == 2"
              >助教</Checkbox
            >
            <Checkbox
              :label="3"
              v-if="
                courseInfo.dispatch_homework.filter((i) => i == 0).length > 0
              "
              >其他老师</Checkbox
            >
            <Checkbox
              :label="4"
              v-if="
                courseInfo.dispatch_homework.filter((i) => i == 1).length > 0 &&
                courseInfo.is_divide_class == 1 &&
                $route.query.type == 2
              "
              >其他助教</Checkbox
            >
          </CheckboxGroup>
        </FormItem>
      </FormItem>
      <FormItem label="课程内容" prop="courses" v-if="$route.query.type == 9">
        <Tag
          type="border"
          closable
          v-for="course in courseInfo.courses"
          :key="course.id"
          @on-close="courseDelete(course.id)"
          >{{ course.title }}</Tag
        >
        <Button type="default" @click="showSelectCourse = true">
          <i class="ivu-icon ivu-icon-ios-add"></i>添加课程
        </Button>
      </FormItem>
      <FormItem
        label="开课时间"
        v-if="$route.query.type == 4"
        prop="playTimeRange"
      >
        <DatePicker
          :editable="false"
          type="datetime"
          placeholder="选择开始时间"
          v-model="courseInfo.playTimeRange[0]"
          @on-change="playTimeRangeChange"
          format="yyyy-MM-dd HH:mm"
          style="width: 200px"
        ></DatePicker>
        <span>~</span>
        <DatePicker
          :editable="false"
          type="datetime"
          placeholder="选择结束时间"
          v-model="courseInfo.playTimeRange[1]"
          @on-change="playTimeRangeChange"
          format="yyyy-MM-dd HH:mm"
          style="width: 200px"
        ></DatePicker>
      </FormItem>
      <FormItem
        v-if="$route.query.type == 4"
        label="云课堂类型"
        prop="cloud_class_type"
      >
        <Select
          :disabled="$route.query.id"
          v-model="courseInfo.cloud_class_type"
          style="width: 100px"
        >
          <Option value="plaso">伯索云</Option>
          <Option value="baijiayun">百家云</Option>
        </Select>
      </FormItem>
      <FormItem label="教室台上容量" prop="stock" v-if="$route.query.type == 3">
        <Select
          v-model="courseInfo.stock"
          style="width: 100px"
          :transfer="true"
        >
          <Option :value="1">1人</Option>
          <Option :value="2">2人</Option>
          <Option :value="3">3人</Option>
          <Option :value="4">4人</Option>
          <Option :value="5">5人</Option>
          <Option :value="6">6人</Option>
          <Option :value="7">7人</Option>
          <Option :value="8">8人</Option>
          <Option :value="9">9人</Option>
          <Option :value="10">10人</Option>
          <Option :value="11">11人</Option>
          <Option :value="12">12人</Option>
        </Select>
        <span class="promt">最多容纳12个学生</span>
      </FormItem>
      <FormItem
        label="教室台下容量"
        prop="off_stock"
        v-if="$route.query.type == 3"
      >
        <Input
          style="width: 150px"
          type="number"
          v-model="courseInfo.off_stock"
          placeholder="请输入教室台下容量"
          @keydown.native="intKeydown"
        />
        <span class="promt">最多容纳300个学生</span>
      </FormItem>
      <FormItem
        label="提前进入教室时间"
        v-if="
          $route.query.type != 5 &&
          $route.query.type != 8 &&
          $route.query.type != 7 &&
          $route.query.type != 9 &&
          $route.query.type != 10
        "
      >
        <RadioGroup v-model="beforeEnterTime" v-if="$route.query.type != 3">
          <Radio :label="0">
            <span>任意时间</span>
          </Radio>
          <Radio :label="1">
            <span>提前</span>
          </Radio>
        </RadioGroup>
        <span v-if="beforeEnterTime == 1 && $route.query.type != 3">
          <Input
            v-model="courseInfo.advance_time"
            type="number"
            :min="1"
            style="width: 50px"
          />分钟才可进入教室
        </span>
        <span class="promt" v-if="$route.query.type == 3"
          >小班课学生提前15分钟进入教室，老师提前30分钟进入教室。</span
        >
      </FormItem>
      <FormItem
        label="报名截止"
        v-if="$route.query.type == 7"
        prop="enter_end_date"
      >
        <DatePicker
          :editable="false"
          type="datetime"
          placeholder="选择报名截止时间"
          v-model="courseInfo.enter_end_date"
          format="yyyy-MM-dd HH:mm"
          :options="enter_end_date_options"
          style="width: 200px"
        ></DatePicker>
      </FormItem>
      <FormItem label="开课地点" prop="address" v-if="$route.query.type == 7">
        <AreaSelect
          :provinceId="courseInfo.province_id"
          :cityId="courseInfo.city_id"
          :districtId="courseInfo.district_id"
          @change="onAreaChange"
        ></AreaSelect>
        <Input
          style="width: 300px"
          type="text"
          v-model="courseInfo.address"
          placeholder="请输入授课地点"
          :maxlength="50"
          clearable
        />
      </FormItem>
      <FormItem label="报名上限" prop="stock" v-if="$route.query.type == 7">
        <Input
          style="width: 150px"
          type="number"
          v-model="courseInfo.stock"
          placeholder="请输入报名上限人数"
          @keydown.native="intKeydown"
        />
      </FormItem>
      <FormItem label="售卖设置" v-if="$route.query.type != 4">
        <RadioGroup v-model="courseInfo.sale_type">
          <Radio :label="1">
            <span>付费</span>
          </Radio>
          <Radio :label="0">
            <span>免费</span>
          </Radio>
        </RadioGroup>
        <div v-if="courseInfo.sale_type == 1" style="margin-left: -60px">
          <FormItem
            label="课程价格"
            prop="price"
            class="form-item-child"
            style="margin-bottom: 24px"
          >
            <Input
              style="width: 150px"
              type="text"
              v-model="courseInfo.price"
              placeholder="请输入价格"
            />
          </FormItem>
          <FormItem
            label="划线价格"
            prop="underlined_price"
            class="form-item-child"
          >
            <Input
              style="width: 150px"
              type="text"
              v-model="courseInfo.underlined_price"
              placeholder="请输入划线价格（选填）"
            />
          </FormItem>
        </div>
      </FormItem>
      <FormItem label="销售基数" v-if="$route.query.type != 4">
        <Input
          style="width: 150px"
          type="number"
          v-model="courseInfo.sales_base"
        />
        <span class="promt">销售基数使前端展示的销售量有虚拟增加</span>
      </FormItem>
      <FormItem label="浏览基数" v-if="$route.query.type == 4">
        <Input
          style="width: 150px"
          type="number"
          v-model="courseInfo.browse_base"
        />
        <span class="promt">浏览基数使前端展示的浏览量有虚拟增加</span>
      </FormItem>

      <FormItem label="赠送积分">
        <Input
          style="width: 150px"
          type="number"
          v-model="courseInfo.gifts_integral"
        />
        <span class="promt">请输入大于0的整数</span>
      </FormItem>

      <FormItem label="赠送图书" prop="books">
        <Tag
          type="border"
          closable
          v-for="book in courseInfo.books"
          :key="book.id"
          @on-close="bookDelete(book.id)"
          style="height: 36px; line-height: 32px"
        >
          {{ book.name }}
        </Tag>
        <Button
          type="default"
          @click="showSelectBook = true"
          :disabled="courseInfo.books.length >= 15"
        >
          <i class="ivu-icon ivu-icon-ios-add"></i>选择图书
        </Button>
        <span class="promt">最多可添加15本图书</span>
      </FormItem>

      <div class="title">上架信息</div>
      <FormItem
        label="目录样式"
        v-if="$route.query.type != 4 && $route.query.type != 9"
      >
        <RadioGroup v-model="courseInfo.display_style" vertical>
          <Radio :label="0">
            <span>课时列表</span>
            <Tooltip
              content="样式为一级目录，即仅显示课时列表，不显示章节信息"
              placement="right"
            >
              <i class="ivu-icon ivu-icon-md-help-circle"></i>
            </Tooltip>
          </Radio>
          <Radio :label="1">
            <span>章节列表</span>
            <Tooltip
              content="样式为二级目录，即点击章节，可查看该章节下的课时列表"
              placement="right"
            >
              <i class="ivu-icon ivu-icon-md-help-circle"></i>
            </Tooltip>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="课程分类" prop="course_classify_ids">
        <Cascader
          :data="catagoris"
          trigger="hover"
          v-model="courseInfo.course_classify_ids"
          change-on-select
          style="width: 200px"
        ></Cascader>
      </FormItem>
      <AttrSelect
        form-url="/api/module/attribute/2"
        :attr="courseInfo.attr"
        @onChange="onAttrChange"
        width="300"
      ></AttrSelect>
      <FormItem style="text-align: center">
        <Button size="large" :to="{ name: 'CourseManage' }">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px"
          type="primary"
          @click="submitForm('courseForm')"
          >保存并返回</Button
        >
      </FormItem>
    </Form>
    <Modal
      class="grid-select"
      v-model="showSelectTeacher"
      title="选择讲师"
      @on-ok="confirmSelectTeacher"
      @on-cancel="$refs.teacher.recoverSelectedItems(courseInfo.teachers)"
      width="800"
      scrollable
    >
      <TeacherSelect
        ref="teacher"
        :selectedItems="courseInfo.teachers"
        :approval_status="2"
      ></TeacherSelect>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectBook"
      title="选择图书"
      width="800"
      scrollable
    >
      <BookSelect
        ref="book"
        :selectedItems="courseInfo.books"
        :approval_status="1"
        :showStock="1"
      ></BookSelect>
      <div slot="footer">
        <Button
          @click="
            $refs.book.recoverSelectedItems(courseInfo.books);
            showSelectBook = false;
          "
          >取消</Button
        >
        <Button type="primary" @click="confirmSelectBook">确定</Button>
      </div>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectAssist"
      title="选择助教"
      @on-ok="confirmSelectAssist"
      @on-cancel="$refs.assist.recoverSelectedItems(courseInfo.assist_teachers)"
      width="800"
      scrollable
    >
      <AssistTeacherSelect
        ref="assist"
        :selectedItems="courseInfo.assist_teachers"
      ></AssistTeacherSelect>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectCourse"
      title="选择课程"
      @on-ok="confirmSelectCourse"
      @on-cancel="$refs.course.recoverSelectedItems(courseInfo.courses)"
      width="800"
      scrollable
    >
      <CourseSelect
        ref="course"
        :selectedItems="courseInfo.courses"
        :status="1"
        :not_include_public_course="1"
        is_include_system_course="0"
        :not_include_system_course="1"
      ></CourseSelect>
    </Modal>
    <Modal
      v-model="showPlanModal"
      title="提示"
      :closable="false"
      :mask-closable="false"
      ok-text="去添加"
      cancel-text="暂时不要了"
      @on-ok="goToPlan"
      @on-cancel="$router.push({ name: 'CourseManage' })"
    >
      <div>
        <i
          class="ivu-icon ivu-icon-ios-checkmark-circle"
          style="font-size: 32px; color: #0194ff"
        ></i
        >恭喜！您已经成功创建了新的课程，别忘了添加课时内容和章节哦。
      </div>
    </Modal>
  </div>
</template>
<script>
import TeacherSelect from "@/components/GridSelect/TeacherSelect.vue";
import UEditor from "@/components/UEditor.vue";
import CourseSelect from "@/components/GridSelect/CourseSelect.vue";
import AreaSelect from "@/components/AreaSelect.vue";
import AttrSelect from "@/components/AttrSelect";
import AssistTeacherSelect from "@/components/GridSelect/AssistTeacherSelect.vue";
import BookSelect from "@/components/GridSelect/BookSelect.vue";
import UploadFile from "@/components/UploadFile.vue";

export default {
  name: "CourseEdit",
  components: {
    TeacherSelect,
    UEditor,
    CourseSelect,
    AreaSelect,
    AttrSelect,
    AssistTeacherSelect,
    UploadFile,
    BookSelect,
  },
  data() {
    const is_divide_class_validator = (rule, value, callback) => {
      if (
        this.courseInfo.is_divide_class == 1 &&
        this.courseInfo.class_num_limit == 1
      ) {
        if (Number(this.courseInfo.class_num) <= 0) {
          callback(new Error("班级人数必须大于0"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      courseInfo: {
        id: "",
        title: "",
        course_details: "",
        advance_time: 15,
        price: "",
        underlined_price: "",
        sales_base: "",
        browse_base: "",
        display_style: 0,
        course_classify_id: null,
        course_classify_ids: [],
        teachers: [],
        sale_type: 1,
        stock: "",
        start_play_date: "",
        end_play_date: "",
        enter_end_date: "",
        address: "",
        courses: [],
        province_id: 0,
        city_id: 0,
        district_id: 0,
        attr: [],
        playTimeRange: ["", ""],
        course_attr: "",
        stock_limit: 0,
        is_divide_class: 1,
        class_num: "",
        class_num_limit: 1,
        assist_teachers: [],
        off_stock: "",
        is_dispatch_homework: 1,
        dispatch_homework: [],
        correct_homework: [],
        gifts_integral: 0,
        books: [],
        cover: "",
        banner: [],
        cloud_class_type: "plaso",
        expiration_note: "",
      },
      stock_old: "",
      off_stock_old: "",
      showSelectTeacher: false,
      showSelectCourse: false,
      showSelectAssist: false,
      showSelectBook: false,
      beforeEnterTime: 1,
      ruleValidate: {
        title: [
          {
            required: true,
            message: "课程名称不能为空",
            trigger: "blur",
          },
        ],
        cover: [
          {
            required: true,
            message: "课程封面不能为空",
          },
        ],
        banner: [
          {
            required: true,
            message: "课程封面不能为空",
          },
        ],
        course_classify_ids: [
          {
            required: true,
            message: "课程分类必须选择",
          },
        ],
        price: [
          {
            required: true,
            message: "课程价格不能为空",
            trigger: "blur",
          },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value != "" && isNaN(value)) {
                callback(new Error("课程价格必须为数字"));
              } else {
                callback();
              }
            },
          },
        ],
        underlined_price: [
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value != "" && isNaN(value)) {
                return callback(new Error("划线价格必须为数字"));
              } else {
                callback();
              }
            },
          },
        ],
        teachers: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "主讲老师必须选择",
            trigger: "change",
          },
          {
            type: "array",
            max: 20,
            message: "主讲老师最多选择20个",
            trigger: "change",
          },
        ],
        off_stock: [
          {
            type: "integer",
            required: true,
            message: "教室台下容量不能为空",
            trigger: "change",
            transform(value) {
              if (!value) {
                return value;
              }
              return Number(value);
            },
          },
          {
            type: "integer",
            min: 1,
            max: 300,
            message: "教室台下容量最少为1，最多300",
            trigger: "change",
            transform(value) {
              return Number(value);
            },
          },
        ],
        courses: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "课程内容不得为空",
            trigger: "change",
          },
        ],
        stock: [],
        playTimeRange: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (value[0] == "") {
                callback(new Error("开始时间不能为空"));
              } else if (value[1] == "") {
                callback(new Error("结束时间不能为空"));
              } else {
                callback();
              }
            },
          },
        ],
        enter_end_date: [
          {
            required: true,
            type: "date",
            message: "报名截止时间不能为空",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "开课地点不能为空",
            trigger: "blur",
          },
        ],
        assist_teachers: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "助教不得为空",
            trigger: "change",
          },
        ],
        dispatch_homework: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "发布作业必须选择",
            trigger: "change",
          },
        ],
        correct_homework: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "批改作业必须选择",
            trigger: "change",
          },
        ],
        is_divide_class: [
          {
            required: true,
            validator: is_divide_class_validator,
          },
        ],
      },
      showSelectCatagory: false,
      showPlanModal: false,
      attrs: [],
      catagoris: [],
      enter_end_date_options: {
        disabledDate: function (date) {
          return date < new Date();
        },
      },
      showClassModule: false,
      showHomeworkModule: false,
      allowChangeClassNum: true,
    };
  },
  async created() {
    this.requestCategories();
    let commonSetting = await this.$http.get("/api/commonSetting");
    this.showClassModule = commonSetting.class_module == 1;
    this.showHomeworkModule = commonSetting.homework_module.is_open == 1;
    if (commonSetting.homework_module.is_open == "1") {
      let settingHw = commonSetting.homework_module.is_hw;
      if (settingHw.is_dispatch == 0) {
        this.courseInfo.is_dispatch_homework = 0;
      } else {
        if (this.$route.query.type == 2) {
          if (settingHw.is_dispatch_hw) {
            settingHw.is_dispatch_hw.split(",").forEach((c) => {
              if (!c) {
                return;
              }
              c = parseInt(c);
              c--;
              this.courseInfo.dispatch_homework.push(parseInt(c));
            });
          }
          if (settingHw.is_correct_hw) {
            settingHw.is_correct_hw.split(",").forEach((c) => {
              if (!c) {
                return;
              }
              c = parseInt(c);
              if (c == 1) {
                c = 0;
              } else if (c == 2) {
                c = 1;
              }
              this.courseInfo.correct_homework.push(c);
            });
          }
        } else {
          this.courseInfo.dispatch_homework.push(0);
          this.courseInfo.correct_homework.push(0);
        }
      }
    }

    if (!this.showClassModule) {
      this.courseInfo.is_divide_class = 0;
    }
    if (!this.showHomeworkModule) {
      this.courseInfo.is_dispatch_homework = 0;
    }

    let type = this.$route.query.type;
    if (type == 3) {
      this.courseInfo.stock = 10;
      this.ruleValidate.stock = [
        {
          required: true,
          type: "number",
          message: "教室容量不能为空",
          trigger: "change",
        },
      ];
      if (!this.$route.query.id) {
        this.courseInfo.off_stock = 300;
      }
    } else if (type == 7 || type == 2 || type == 5 || type == 8 || type == 10) {
      this.ruleValidate.stock = [
        {
          type: "number",
          trigger: "change",
          required: type != 7,
          validator: (rule, value, callback) => {
            if (value == "") {
              callback();
              return;
            }
            if (parseInt(value) <= 0) {
              if (type == 7) {
                callback(new Error("报名上限必须大于0"));
              } else {
                callback(new Error("库存必须大于0"));
              }
            } else {
              callback();
            }
          },
        },
      ];
    }
    await this.getCourseInfo();
  },
  methods: {
    async requestCategories() {
      let catagoris = await this.$http.get("/api/course/classify");
      catagoris.forEach((c) => {
        c.value = c.id;
        c.label = c.name;
        if (c.children) {
          c.children.forEach((child) => {
            child.value = child.id;
            child.label = child.name;
          });
        }
      });
      this.catagoris = catagoris;
    },

    onUploadSuccess(data) {
      this.courseInfo.cover = data.path;
    },
    onBannerUploadSuccess(data) {
      this.courseInfo.banner.push(data.path);
    },
    onRemoveImage(index) {
      this.courseInfo.banner.splice(index, 1);
    },
    onAttrChange(val) {
      this.courseInfo.course_attr = val;
    },
    async getCourseInfo() {
      if (!this.courseInfo.expiration_note) {
        const year = new Date().getFullYear();
        this.courseInfo.expiration_note = `默认有效期至${year}年12月31日`;
      }

      let id = this.$route.query.id;
      if (!id) {
        return;
      }
      let data = await this.$http.get("/api/course/basis/" + id);
      this.courseInfo.title = data.title;
      data.course_teacher.forEach((t) => {
        this.courseInfo.teachers.push({
          id: t.teacher_id,
          real_name: t.teacher_name,
          avatar: t.avatar,
        });
      });
      this.courseInfo.books = data.books || [];
      this.courseInfo.cover = data.cover;
      this.courseInfo.banner = data.banner;
      this.courseInfo.course_details = data.course_detail;
      this.beforeEnterTime = data.advance_time == 0 ? 0 : 1;
      this.courseInfo.advance_time = data.advance_time;
      this.courseInfo.sale_type = data.sale_type;
      this.courseInfo.price = (data.price / 100).toString();
      this.courseInfo.underlined_price = data.underlined_price / 100;
      this.courseInfo.sales_base = data.sales_base;
      this.courseInfo.display_style = data.display_style;
      this.courseInfo.course_classify_id = data.course_classify_id;
      this.courseInfo.gifts_integral = data.gifts_integral;
      this.courseInfo.course_classify_ids = [data.course_classify_id, 0];
      for (let i = 0; i < this.catagoris.length; i++) {
        let catagory = this.catagoris[i];
        if (!catagory.children) {
          continue;
        }
        let j = 0;
        for (; j < catagory.children.length; j++) {
          let childCatagory = catagory.children[j];
          if (childCatagory.id != data.course_classify_id) {
            continue;
          }
          this.courseInfo.course_classify_ids = [
            catagory.id,
            data.course_classify_id,
          ];
          break;
        }
        if (j < catagory.children.length) {
          break;
        }
      }

      this.courseInfo.stock = data.stock >= 999999 ? "" : data.stock;
      this.stock_old = this.courseInfo.stock;
      this.courseInfo.courses = data.course_item || [];
      this.courseInfo.browse_base = data.browse_base;
      if (data.course_type == 7) {
        this.courseInfo.address = data.course_address.address;
        this.courseInfo.province_id = data.course_address.province_id;
        this.courseInfo.city_id = data.course_address.city_id;
        this.courseInfo.district_id = data.course_address.district_id;
      }
      if (data.course_type == 4) {
        let range = [];
        range.push(new Date(data.start_play_date * 1000));
        range.push(new Date(data.end_play_date * 1000));
        this.courseInfo.playTimeRange = range;
        this.courseInfo.start_play_date = range[0].format("yyyy-MM-dd hh:mm");
        this.courseInfo.end_play_date = range[1].format("yyyy-MM-dd hh:mm");
      } else if (data.course_type == 7) {
        if (data.enter_end_date != 0) {
          this.courseInfo.enter_end_date = new Date(
            data.enter_end_date * 1000
          ).format("yyyy-MM-dd hh:mm");
        }
      }
      data.course_attr.forEach((attr) => {
        this.courseInfo.attr.push(attr);
      });
      if (
        data.course_type == 2 ||
        data.course_type == 5 ||
        data.course_type == 8 ||
        data.course_type == 10
      ) {
        if (data.stock >= 999999) {
          this.courseInfo.stock_limit = 0;
        } else {
          this.courseInfo.stock_limit = 1;
        }
      }
      if (data.course_type == 2) {
        this.courseInfo.is_divide_class = data.is_divide_class;
        if (data.class_num == -1) {
          this.courseInfo.class_num_limit = 0;
        } else {
          this.courseInfo.class_num = data.class_num;
        }
        if (data.assist_course_teacher) {
          data.assist_course_teacher.forEach((t) => {
            this.courseInfo.assist_teachers.push({
              id: t.teacher_id,
              real_name: t.teacher_name,
              avatar: t.avatar,
            });
          });
        }
      }
      this.courseInfo.off_stock = data.off_stock;
      this.courseInfo.is_dispatch_homework = data.is_dispatch_homework;
      if (data.is_dispatch_homework == 1) {
        if (data.dispatch_homework == 2) {
          this.courseInfo.dispatch_homework = [0, 1];
        } else {
          this.courseInfo.dispatch_homework = [data.dispatch_homework];
        }
        if (data.correct_homework == 2) {
          this.courseInfo.correct_homework = [0, 1];
        } else {
          this.courseInfo.correct_homework = [data.correct_homework];
        }
        if (data.correct_homework_other_teacher) {
          this.courseInfo.correct_homework.push(3);
        }
        if (data.correct_homework_other_assist) {
          this.courseInfo.correct_homework.push(4);
        }
      }
      this.off_stock_old = this.courseInfo.off_stock;
      if (
        this.courseInfo.is_divide_class == 1 &&
        this.courseInfo.class_num_limit == 0
      ) {
        this.allowChangeClassNum = false;
      }
    },
    confirmSelectTeacher() {
      this.showSelectTeacher = false;
      let list = this.$refs.teacher.getSelectList();
      this.courseInfo.teachers = list;
      this.$refs["courseForm"].validateField("teachers");
    },
    confirmSelectAssist() {
      this.showSelectAssist = false;
      let list = this.$refs.assist.getSelectList();
      this.courseInfo.assist_teachers = list;
      this.$refs["courseForm"].validateField("assist_teachers");
    },
    confirmSelectBook() {
      // this.showSelectBook = false;
      let list = this.$refs.book.getSelectList();
      // this.courseInfo.books = [];
      let isZeroStock = 0;
      list.forEach((c, i) => {
        if (c.stock <= 0) {
          isZeroStock = 1;
          return;
        }
      });
      if (isZeroStock > 0) {
        this.$promiseAlert("对不起，存在图书库存不足不可选择!");
        return;
      }
      if (list.length > 15) {
        this.$promiseAlert("最多可添加15本图书!");
        return;
      }
      if (list.length) {
        this.courseInfo.books = list;
      }
      this.showSelectBook = false;
    },
    confirmSelectCourse() {
      this.showSelectCourse = false;
      let list = this.$refs.course.getSelectList();
      this.courseInfo.courses = list;
    },
    teacherDelete(id) {
      let teachers = this.courseInfo.teachers;
      for (let i = 0; i < teachers.length; i++) {
        if (teachers[i].id == id) {
          teachers.splice(i, 1);
          break;
        }
      }
    },
    assistDelete(id) {
      let teachers = this.courseInfo.assist_teachers;
      for (let i = 0; i < teachers.length; i++) {
        if (teachers[i].id == id) {
          teachers.splice(i, 1);
          break;
        }
      }
    },
    bookDelete(id) {
      let books = this.courseInfo.books;
      for (let i = 0; i < books.length; i++) {
        if (books[i].id == id) {
          books.splice(i, 1);
          break;
        }
      }
    },
    courseDelete(id) {
      let courses = this.courseInfo.courses;
      for (let i = 0; i < courses.length; i++) {
        if (courses[i].id == id) {
          courses.splice(i, 1);
          break;
        }
      }
    },
    submitForm(ref) {
      this.$refs[ref].validate(async (valid) => {
        if (!valid) {
          return;
        }
        let id = this.$route.query.id;
        if (
          id &&
          this.$route.query.type == 3 &&
          (this.courseInfo.stock != this.stock_old ||
            this.courseInfo.off_stock != this.off_stock_old)
        ) {
          await this.$promiseConfirm(
            "修改教室台上/台下人数，对已结束和正在直播不生效，只对小班课即将开始的课时生效，是否确认修改",
            "提示"
          );
        }
        this.courseInfo.id = id;
        let data = {};
        data.course_type = this.$route.query.type;
        data.expiration_note = this.courseInfo.expiration_note;
        data.course_classify_id =
          this.courseInfo.course_classify_ids[1] ||
          this.courseInfo.course_classify_ids[0];
        data.title = this.courseInfo.title;
        if (data.course_type != 4) {
          data.sale_type = this.courseInfo.sale_type;
          if (data.sale_type == 0) {
            data.price = 0;
            data.underlined_price = 0;
          } else {
            data.price = this.courseInfo.price * 100;
            data.underlined_price = this.courseInfo.underlined_price * 100;
          }
        }

        data.display_style = this.courseInfo.display_style;
        data.sales_base = this.courseInfo.sales_base;
        data.browse_base = this.courseInfo.browse_base || 0;
        if (this.$route.query.type == 3) {
          data.advance_time = 15;
        } else {
          if (this.beforeEnterTime == 0) {
            data.advance_time = 0;
          } else {
            data.advance_time = this.courseInfo.advance_time;
          }
        }
        if (
          data.course_type == 2 ||
          data.course_type == 5 ||
          data.course_type == 8 ||
          data.course_type == 10
        ) {
          if (this.courseInfo.stock_limit == 1) {
            data.stock = this.courseInfo.stock;
          } else {
            data.stock = 999999;
          }
        } else {
          data.stock = this.courseInfo.stock;
        }
        data.start_play_date = this.courseInfo.start_play_date;
        if (data.course_type == 7) {
          if (!this.courseInfo.enter_end_date) {
            data.enter_end_date = "";
          } else {
            data.enter_end_date =
              this.courseInfo.enter_end_date.format("yyyy-MM-dd hh:mm");
          }
        } else {
          data.end_play_date = this.courseInfo.end_play_date;
        }
        data.course_details = this.courseInfo.course_details;
        data.teacher_ids = [];
        this.courseInfo.teachers.forEach((t) => {
          if (
            data.teacher_ids.filter((dt) => dt.teacher_id == t.id).length == 0
          ) {
            data.teacher_ids.push({
              teacher_id: t.id,
              teacher_name: t.real_name,
            });
          }
        });
        data.teacher_ids = JSON.stringify(data.teacher_ids);

        if (data.course_type == 2) {
          data.is_divide_class = this.courseInfo.is_divide_class;
        } else {
          data.is_divide_class = 0;
        }
        data.assist_teacher_ids = [];
        if (this.courseInfo.is_divide_class == 1) {
          if (this.courseInfo.class_num_limit == 1) {
            data.class_num = this.courseInfo.class_num;
          } else {
            data.class_num = -1;
          }
          this.courseInfo.assist_teachers.forEach((t) => {
            if (
              data.assist_teacher_ids.filter((dt) => dt.teacher_id == t.id)
                .length == 0
            ) {
              data.assist_teacher_ids.push({
                teacher_id: t.id,
                teacher_name: t.real_name,
              });
            }
          });
        }
        data.assist_teacher_ids = JSON.stringify(data.assist_teacher_ids);

        let courseIds = [];
        this.courseInfo.courses.forEach((c) => {
          courseIds.push(c.id);
        });
        data.basis_ids = courseIds.join(",");
        data.province_id = this.courseInfo.province_id;
        data.city_id = this.courseInfo.city_id;
        data.district_id = this.courseInfo.district_id;
        data.address = this.courseInfo.address;
        data.course_attr = this.courseInfo.course_attr;
        if (data.course_type == 3) {
          data.off_stock = this.courseInfo.off_stock;
        } else {
          data.off_stock = "";
        }
        data.is_dispatch_homework = this.courseInfo.is_dispatch_homework;
        if (data.is_dispatch_homework == 1) {
          if (this.courseInfo.dispatch_homework.length > 1) {
            data.dispatch_homework = 2;
          } else {
            data.dispatch_homework = this.courseInfo.dispatch_homework[0];
          }

          if (
            this.courseInfo.dispatch_homework.indexOf(0) >= 0 &&
            this.courseInfo.correct_homework.indexOf(3) >= 0
          ) {
            data.correct_homework_other_teacher = 1;
          } else {
            data.correct_homework_other_teacher = 0;
          }
          if (
            this.courseInfo.dispatch_homework.indexOf(1) >= 0 &&
            this.courseInfo.correct_homework.indexOf(4) >= 0
          ) {
            data.correct_homework_other_assist = 1;
          } else {
            data.correct_homework_other_assist = 0;
          }
          let correct_homework_list = this.courseInfo.correct_homework.filter(
            (c) => c != 3 && c != 4
          );
          if (correct_homework_list.length > 1) {
            data.correct_homework = 2;
          } else {
            data.correct_homework = correct_homework_list[0];
            if (data.correct_homework === undefined) {
              data.correct_homework = "";
            }
          }
        } else {
          data.dispatch_homework = "";
          data.correct_homework = "";
        }
        data.gifts_integral = this.courseInfo.gifts_integral;
        data.books = this.courseInfo.books;
        data.cover = this.courseInfo.cover;
        data.banner = this.courseInfo.banner.join(",");
        data.cloud_class_type = this.courseInfo.cloud_class_type;
        console.log(data);
        if (id) {
          data.id = id;
          await this.$http.put("/api/course/basis", data);
        } else {
          let result = await this.$http.post("/api/course/basis", data);
          this.courseInfo.id = result.id;
        }
        if (data.course_type == 4 || data.course_type == 9 || id) {
          if (id) {
            this.$Message.saveSuccess();
          } else {
            this.$Message.createSuccess();
          }
          this.$router.push({ name: "CourseManage" });
        } else {
          this.showPlanModal = true;
        }
      });
    },
    goToPlan() {
      this.$router.push({
        name: "CoursePlan",
        query: { id: this.courseInfo.id },
      });
    },
    playTimeRangeChange() {
      let playTimeRange = this.courseInfo.playTimeRange;
      if (playTimeRange[0] == "") {
        this.courseInfo.start_play_date = "";
      } else {
        this.courseInfo.start_play_date =
          playTimeRange[0].format("yyyy-MM-dd hh:mm");
      }
      if (playTimeRange[1] == "") {
        this.courseInfo.end_play_date = "";
      } else {
        this.courseInfo.end_play_date =
          playTimeRange[1].format("yyyy-MM-dd hh:mm");
      }
    },
    intKeydown(event) {
      if (event.keyCode == 190 || event.keyCode == 189) {
        event.preventDefault();
      }
      if (event.keyCode == 48 && event.target.value == "") {
        event.preventDefault();
      }
      if (event.keyCode == 8) {
        let value = event.target.value;
        if (value.length == 2 && value[0] == "0") {
          event.target.value = "";
          let customEvent = document.createEvent("HTMLEvents");
          customEvent.initEvent("input", false, true);
          event.target.dispatchEvent(customEvent);
        }
      }
    },
    onAreaChange(area) {
      this.courseInfo.province_id = area.provinceId;
      this.courseInfo.city_id = area.cityId;
      this.courseInfo.district_id = area.districtId;
    },
    onStockLimitChange() {
      if (this.courseInfo.stock_limit == 0) {
        this.courseInfo.stock = "";
      }
    },
    async onClassNumLimitChange() {
      if (this.courseInfo.class_num_limit == 0) {
        await this.$promiseConfirm(
          "选择不限制班级人数后，不支持再次限制班级人数，是否确定选择？",
          "提示",
          {
            onCancel: () => {
              this.courseInfo.class_num_limit = 1;
            },
            onOk: () => {
              this.courseInfo.class_num = "";
            },
          }
        );
      }
    },
  },
  watch: {
    "courseInfo.class_num": function (newValue, oldValue) {
      if (this.$route.query.type != 2 || !this.$route.query.id || !oldValue) {
        return;
      }
      this.$promiseConfirm(
        "班级设置调整，调整只对后续购买该课程的学员生效，已自动分班满员的班级学员不受影响，是否确认调整？",
        "提示",
        {
          onCancel: () => {
            this.courseInfo.class_num = oldValue;
            this.courseInfo.class_num_limit = 1;
          },
        }
      );
    },
    "courseInfo.is_dispatch_homework": function () {
      if (
        this.courseInfo.is_dispatch_homework == 1 &&
        this.$route.query.type != 2
      ) {
        this.courseInfo.dispatch_homework = [0];
        this.courseInfo.correct_homework = [0];
      }
    },
  },
};
</script>
<style lang="scss">
.promt {
  color: #ccc;
}

.ivu-tooltip-inner {
  max-width: 400px;
}

.form-item-child .ivu-form-item-error-tip {
  margin-left: 120px;
}

.form-item-sub {
  &:nth-child(2) {
    margin-bottom: 24px !important;
  }
  .ivu-form-item-label {
    width: auto !important;
  }
}
.course-banners {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
}
.course-banner {
  position: relative;
  .delete {
    right: -5px;
    position: absolute;
    top: -6px;
  }
}
</style>
